import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-basic",
  "use": "icon-basic-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-basic\"><defs><style type=\"text/css\"></style></defs><path d=\"M745.6 598.4c6.4 0 12.8 0 22.4 3.2V172.8H342.4L172.8 384v425.6h441.6c-9.6-19.2-16-41.6-16-64 0-83.2 64-147.2 147.2-147.2zM512 256h169.6v86.4H512V256z m0 256v-86.4h169.6V512H512z m256 169.6c-48 0-86.4 38.4-86.4 86.4 0 48 38.4 86.4 86.4 86.4 48 0 86.4-38.4 86.4-86.4-3.2-48-38.4-86.4-86.4-86.4z\" p-id=\"1837\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol